/*!
  * Furillo no-referrer.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
export default function (element) {
    element.querySelectorAll('a[href^="http"]').forEach(a => {

        // Check that rel isn't already defined
        const rel = a.getAttribute('rel');
        if (typeof rel !== typeof undefined && rel !== null && rel !== false)
            return;

        // Check that it isn't same origin
        const href = a.getAttribute('href');
        if (href.startsWith(window.location.origin))
            return;

        // Set no referrer to everything else
        a.setAttribute('rel', 'noreferrer');
    });
}